"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClusterPointType = exports.ToolTipType = exports.PointType = exports.DepotType = exports.EDepotType = exports.FillType = exports.StopType = void 0;
var StopType;
(function (StopType) {
    StopType["COMPLETE_CONTAINER_STOP"] = "complete_container_stop";
    StopType["COMPLETE_INQUIRY_STOP"] = "complete_inquiry_stop";
    StopType["CREATED_INQUIRY_EMPTIED"] = "created_inquiry_emptied";
    StopType["CREATED_INQUIRY_NON_EMPTIED"] = "created_inquiry_non_emptied";
    StopType["PENDING_CONTAINER_STOP"] = "pending_container_stop";
    StopType["PENDING_INQUIRY_STOP"] = "pending_inquiry_stop";
    StopType["CURRENT_CONTAINER_STOP"] = "current_container_stop";
    StopType["CURRENT_INQUIRY_STOP"] = "current_inquiry_stop";
})(StopType = exports.StopType || (exports.StopType = {}));
var FillType;
(function (FillType) {
    FillType["LOW_FILLED_LEVEL"] = "low_filled_level";
    FillType["MEDIUM_FILLED_LEVEL"] = "medium_filled_level";
    FillType["HIGH_FILLED_LEVEL"] = "high_filled_level";
    FillType["STATIC_CONTAINER"] = "static_container";
})(FillType = exports.FillType || (exports.FillType = {}));
var EDepotType;
(function (EDepotType) {
    EDepotType["CURRENT_DEPOT_STOP"] = "current_depot_stop";
    EDepotType["CURRENT_WASTE_STOP"] = "current_waste_stop";
    EDepotType["COMPLETE_WASTE_STATION"] = "complete_waste_station";
    EDepotType["PENDING_WASTE_STATION"] = "pending_waste_station";
    EDepotType["COMPLETE_DEPOT"] = "complete_depot";
    EDepotType["PENDING_DEPOT"] = "pending_depot";
    EDepotType["DEPOT_STATION"] = "depot_station";
    EDepotType["WASTE_STATION"] = "waste_station";
})(EDepotType = exports.EDepotType || (exports.EDepotType = {}));
var DepotType;
(function (DepotType) {
    DepotType["WASTE_STATION"] = "waste_station";
    DepotType["DEPOT"] = "depot";
})(DepotType = exports.DepotType || (exports.DepotType = {}));
var PointType;
(function (PointType) {
    PointType["Containers"] = "container";
    PointType["Routes"] = "routes";
    PointType["Inquiries"] = "inquiries";
    PointType["Vehicles"] = "vehicles";
    PointType["Depots"] = "depots";
    PointType["Stops"] = "stops";
    PointType["FilledLevels"] = "filledlevels";
})(PointType = exports.PointType || (exports.PointType = {}));
var ToolTipType;
(function (ToolTipType) {
    ToolTipType["LongContainer"] = "longcontainer";
    ToolTipType["SmallContainer"] = "smallcontainer";
})(ToolTipType = exports.ToolTipType || (exports.ToolTipType = {}));
var ClusterPointType;
(function (ClusterPointType) {
    ClusterPointType["PENDING_MULTIPLE_STOPS"] = "pending_multiple_stops";
    ClusterPointType["COMPLETED_MULTIPLE_STOPS"] = "completed_multiple_stops";
    ClusterPointType["CURRENT_PENDING_MULITPLE_STOPS"] = "current_pending_mulitple_stops";
    ClusterPointType["MULTIPLE_FILLED_MARKER"] = "multiple_filled_marker";
    ClusterPointType["LOW_HIGH_FILLED_MARKER"] = "low_high_filled_marker";
    ClusterPointType["MEDIUM_HIGH_FILLED_MARKER"] = "medium_high_filled_marker";
    ClusterPointType["STATIC_HIGH_FILLED_MARKER"] = "static_high_filled_marker";
})(ClusterPointType = exports.ClusterPointType || (exports.ClusterPointType = {}));
